import React, { useState } from "react";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import YearPage from "./components/YearPage";
import "./styles/style.scss";

const App = () => {
	const [currentPage, setCurrentPage] = useState("home");

	const years = [
		"2025",
		"2024",
		"2023",
		"2022",
		"2021",
		"2020",
		"2019",
		"2018",
		"2017",
		"2016",
		"2015",
		"2014",
		"2013",
		"2012",
		"2011",
		"2010",
	];

	return (
		<div>
			<Navbar
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				years={years}
			/>

			<main>
				{currentPage === "home" ? (
					<HomePage setCurrentPage={setCurrentPage} />
				) : (
					<YearPage year={currentPage} />
				)}
			</main>

			<footer>
				<div className="footer">
					<div className="footer__text">
						<p>Website created by Noah Nemec</p>
						<p>© Noah Nemec</p>
					</div>
				</div>
			</footer>
		</div>
	);
};

export default App;
